// 曜日の定義
const week = ["日", "月", "火", "水", "木", "金", "土"];

// 今日の日付
var today = new Date();

var extension_count = 0;

// 表示用の日付
var showDate = new Date(today.getFullYear(), today.getMonth(), 1);

// 表示される年
var year = ""

// 表示される月
var month = ""

// 選択状況フラグ
let selectFlag = Boolean(false);

// 選択状況フラグ（２回目以降）
let selectedFlag = Boolean(false);

// 選択開始日
let start_date = new Date(today.getFullYear(), today.getMonth(), 1);

// 選択終了日
let end_date =  new Date(today.getFullYear(), today.getMonth(), 1);

// 選択開始日
let send_date = new Date(today.getFullYear(), today.getMonth(), 1);

// 選択終了日
let return_date =  new Date(today.getFullYear(), today.getMonth(), 1);

//　お届け予定日（配達日より〇日前）
let arrive_date_num_before_start_date = 4

// 規定レンタル日数
let default_rental_date = 6

// 規定延長料金
let extension_base_fee = 220

// 表示された時
window.onload = function () {
  // 商品タイプによってお届け日を変更
  switch(productType){
　case "rental_weddingDress":
　　　　arrive_date_num_before_start_date = 4;
　　　　　　 　　break;
　case "rental_mofuku":
　　　　arrive_date_num_before_start_date = 1
　　　　　　 　　break;
  }
  // 商品タイプによって規定レンタル日数を変更
  switch(productType){
　case "rental_weddingDress":
　　　　default_rental_date = 6;
　　　　　　 　　break;
　case "rental_mofuku":
　　　　default_rental_date = 4;
　　　　　　 　　break;
  }
  // 商品タイプによって規定延長料金を変更
  switch(productType){
　case "rental_weddingDress":
　　　　extension_base_fee = 220;
　　　　　　 　　break;
　case "rental_mofuku":
　　　　extension_base_fee = 1000;
　　　　　　 　　break;
  }
  // カレンダーの表示（引数には表示用の日付を設定）
  showCalendar(showDate);
};

/**
 * カレンダーの表示
 */
function showCalendar(date) {
  // 年
  year = date.getFullYear();
  // 月
  month = date.getMonth() + 1;
  
  // ヘッダーの年月に表示する文字列
  var showDateStr = year + "年 " + month + "月";
  
  // ヘッダーの年月部分に埋め込み
  document.querySelector('#year_month_label').innerHTML = showDateStr;
  
  // カレンダーテーブルを作成する（HTMLが返却される）
  var calendarTable = createCalendarTable(year, month);
  
  // カレンダー表示部分に埋め込み
  document.querySelector('#calendar_body').innerHTML = calendarTable;
}

/**
 * カレンダーテーブルの作成
 */
function createCalendarTable(year, month) {
  // HTML用の変数
  var _html = '';
  
  // tableタグ
  _html += '<table class="calendar_tbl" id="calendar_tbl_id">';
  
  // テーブルのヘッダー（曜日）
  _html += '<tr>';
  for (var i = 0; i < week.length; i++) {
    _html += "<th>" + week[i] + "</th>";
  }
  _html += '</tr>';
  
  // ---------------------
  
  // 表示するカレンダー年月の1日の曜日を取得
  var startDayOfWeek = new Date(year, month - 1, 1).getDay();
  
  // 日付
  var countDay = 0;
  
  // 月の末日
  var monthOfEndDay = new Date(year, month, 0).getDate()
  
  // 6行分繰り返し
  for (var i = 0; i < 6; i++) {
    _html += '<tr>';
    
    // 7列（曜日の数）分繰り返し
    for (var j = 0; j < week.length; j++) {
      // １行目で開始曜日と同じ場合
      if (i == 0 && j == startDayOfWeek) {
        // 日付+1
        countDay++;
        // tdタグ（日付有りが分かるようにクラス属性に"with_date"を設定）
        _html += '<td class="with_date" id=j onclick="show(this)">' + countDay + '</td>';
      }
      // 日付が0以外で、日付が末日より小さい場合
      else if (countDay != 0 && countDay < monthOfEndDay) {
        // 日付+1
        countDay++;
        // tdタグ（日付有りが分かるようにクラス属性に"with_date"を設定）
        _html += '<td class="with_date" onclick="show(this)">' + countDay + '</td>';
      }
      else {
        // tdタグ（日付無しが分かるようにクラス属性に"no_date"を設定）
        _html += '<td class="no_date"></td>';
      }
    }
    _html += '</tr>';
  }
  _html += '</table>';
  
  // 組み立てたHTMLを返却
  return _html;
}

/**
 * 前年
 */
function prev_year() {
  console.log("前年度に移動");
  // 表示用の日付の年-1を設定
  showDate.setFullYear(showDate.getFullYear() - 1);
  // カレンダーの表示（引数には表示用の日付を設定）
  showCalendar(showDate);
}

/**
 * 前月
 */
function prev_month() {
  // 表示用の日付の月-1を設定
  showDate.setMonth(showDate.getMonth() - 1);
  // カレンダーの表示（引数には表示用の日付を設定）
  showCalendar(showDate);
}

/**
 * 今日
 */
function now_month() {
  // 表示用の日付に今日の日付を設定
  showDate = new Date();
  // カレンダーの表示（引数には表示用の日付を設定）
  showCalendar(showDate);
}

/**
 * 来月
 */
function next_month() {
  // 表示用の日付の月+1を設定
  showDate.setMonth(showDate.getMonth() + 1);
  // カレンダーの表示（引数には表示用の日付を設定）
  showCalendar(showDate);
}

/**
 * 来年
 */
function next_year() {
  // 表示用の日付の年+1を設定
  showDate.setFullYear(showDate.getFullYear() + 1);
  // カレンダーの表示（引数には表示用の日付を設定）
  showCalendar(showDate);
}  

//日付加算関数
function addDays(date, n){
  date.setDate(date.getDate() + n)
}

//カレンダー選択時
function show(e) {
  var calendar_table = document.getElementById("calendar_tbl_id");
  var date = e.textContent;
  console.log(price);
  console.log(productType);
  

  if(selectFlag){
    //レンタル終了日宣言
    end_date.setFullYear(year,month-1,date);
    console.log(end_date);
    //返却日設定
    return_date.setFullYear(end_date.getFullYear(),end_date.getMonth(),end_date.getDate()+1);
    let return_year = return_date.getFullYear();
    let return_month = return_date.getMonth()+1;
    let return_day = return_date.getDate();
    
    //レンタル返却日宣言
    if(start_date >= end_date){
      alert("終了日は開始日より後の日付を選択してください。");
    }else{
      document.getElementById("end_yyyymmdd").value = year+"年"+month+"月"+date+"日";
      document.getElementById("input_return_date").value = return_year+"年"+return_month+"月"+return_day+"日";

      extension_count = (end_date - start_date) / 86400000 - (default_rental_date - 1);
      calculate_extension_fee();
      //セル背景を変更（終了日日～）
      e.style.backgroundColor='#ff8c00'; 
      selectFlag = false;
      selectedFlag = true;
           
    }
  }else{
    if (selectedFlag) {
      document.getElementById("end_yyyymmdd").value = "";
      document.getElementById("extension_fee").value = "" ;
      document.getElementById("input_return_date").value = "" ;
      for (var i=0; i < calendar_table.rows.length; i++) {
        for (var j=0; j < calendar_table.rows[i].cells.length; j++) {
          calendar_table.rows[i].cells[j].style.backgroundColor =''
        }
      }
    }
    //レンタル開始日宣言
    start_date.setFullYear(year,month-1,date);
    //配達日設定
    send_date.setFullYear(start_date.getFullYear(),start_date.getMonth(),start_date.getDate()-arrive_date_num_before_start_date);
    let send_year = send_date.getFullYear();
    let send_month = send_date.getMonth()+1;
    let send_day = send_date.getDate();
    document.getElementById("start_yyyymmdd").value = year+"年"+month+"月"+date+"日";
    document.getElementById("input_send_date").value = send_year+"年"+send_month+"月"+send_day+"日";
    selectFlag = true;

    //セル背景を変更（開始日～）
    e.style.backgroundColor='#7fffd4';
	}
}
function calculate_extension_fee(){
  var selected_count = document.getElementsByName("quantity")[0].value;
  var extension_fee = selected_count*extension_count*extension_base_fee;
  if(extension_fee>0){
    document.getElementById("extension_fee").value = extension_fee + "円" ;
  }else{
    document.getElementById("extension_fee").value = 0 + "円" ;
  }
  }






